// 顶级状态

export const SET_DEBUG = 'SET_DEBUG'; // debug

export const SET_TITLE = 'SET_TITLE'; // 标题

export const SET_SHARE_WECHAT = 'SET_SHARE_WECHAT'; // 微信分享遮罩层

export const SET_VISIBLE_TOP = 'SET_VISIBLE_TOP'; // 顶部导航栏

export const SET_NAVIGATION_APP = 'SET_NAVIGATION_APP'; // 打开APP导航栏

export const SET_HIDE_TOP_ROUTERS = 'SET_HIDE_TOP_ROUTERS'; // 隐藏顶部导航栏路由

// =============  user userInfo 用户状态  =============

export const USER_USERINFO_CLEAR = 'USER_USERINFO_CLEAR'; // 用户信息清除

export const USER_USERINFO_UPDATE = 'USER_USERINFO_UPDATE'; // 用户信息更新
